import axios from "axios";

const state = {
  agencyBadgesList: [],
  selectedCandidateBadges: []
};

const mutations = {
  setBadges(state, payload) {
    state.agencyBadgesList = payload;
  },
  addBadge(state, payload) {
    state.agencyBadgesList.push(payload);
  },
  updateBadge(state, payload){
    const index = state.agencyBadgesList.findIndex(
      element => element.id === payload.id
    );
    state.agencyBadgesList[index] = payload;
  },
  removeBadge(state, payload) {
    const index = state.agencyBadgesList.findIndex(
      element => element.id === payload.badgeId
    );
    state.agencyBadgesList.splice(index, 1);
  },
  setSelectedCandidateBadges(state, payload) {
    state.selectedCandidateBadges = payload;
  }
};
const actions = {
  async getAllBadges(context, payload) {
    try {
      const response = await axios.get(
        `/api/agency_badge/?agency_id=${payload.agencyId}`
      );
      console.log(response);
      if (response.status === 200) {
        context.commit("setBadges", response.data);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async addNewBadge(context, payload) {
    try {
      const response = await axios.post("/api/agency_badge/create/", payload);
      if (response.status === 201) {
        context.commit("addBadge", response.data);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async updateBadge(context, payload){
    try {
      const form = new FormData();

      if(payload.badge_image instanceof File){
        form.append("badge_image", payload.badge_image);
      }
      form.append("badge_name", payload.badge_name);
      form.append("review_required", payload.review_required)
      if(payload.review_required){
        form.append("email", payload.email)
      }
      form.append("agency", payload.agency);
      const response = await axios.patch("/api/agency_badge/update/"+payload.id, form);
      if (response.status === 200) {
        context.commit("updateBadge", response.data);
        return response
      }
    } catch (error) {
      console.error(error);
    }
  },
  async deleteBadge(context, payload) {
    try {
      const response = await axios.delete(
        `/api/agency_badge/delete/${payload.badgeId}`
      );
      if (response.status === 204) {
        context.commit("removeBadge", payload);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async addCandidateBadges(_, payload) {
    try {
      return await axios.put("api/candidate_badge/update/", payload);
    } catch (error) {
      console.error(error);
    }
  },
  async getCandidateBadge(context, payload) {
    try {
      const response = await axios.get(
        `api/candidate_badge/?candidate_id=${payload.candidateId}`
      );
      context.commit("setSelectedCandidateBadges", response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async deleteCandidateBadges(context, payload) {
    try {
      await axios.delete(`api/candidate_badge/delete/${payload.candidateId}`);
      context.commit("setSelectedCandidateBadges", []);
    } catch (error) {
      console.error(error);
    }
  }
};
const getters = {
  getBadges(state) {
    return state.agencyBadgesList;
  },
  getSelectedCandidateBadges(state) {
    return state.selectedCandidateBadges;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/badges.js